module.exports = __webpack_public_path__ + "img/trappedKnight.4bfdb2b9.png";